import PropTypes from 'prop-types'
import React, { Component } from 'react'

import ListItem from './ListItem'

export default class ReleaseTabDeclined extends Component {

  static propTypes = {
    data: PropTypes.object
  }

  render() {
    const { data } = this.props
    const list = data.collection.filter(item => item.dirtyStatus)
      .sort((item1, item2) => {
        const date1 = new Date(item1.updatedAt).getTime()
        const date2 = new Date(item2.updatedAt).getTime()
        return date2 - date1
      })

    const key = item => (typeof item === 'string' ? item : item.id)

    return (
      <div>
        <h5>
          Abgelehnte Museen und Programme{' '}
          <small>(liegen beim Museum zur Bearbeitung)</small>
        </h5>
        <ul className="nav-list rejected-list vertical">
          {list.map(itm => <ListItem key={key(itm)} item={itm} />)}
        </ul>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/release/components/TabDeclined.js